import { render, staticRenderFns } from "./EditableEventCard.vue?vue&type=template&id=b179c4ca&"
import script from "./EditableEventCard.vue?vue&type=script&lang=js&"
export * from "./EditableEventCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports